module.exports = __webpack_public_path__ + "media/images/fb-icon-6b93b83a1691b29a3d78f9bbaae7a5dd.png";